import { ReactNode } from "react";
import { Box, Skeleton, Typography, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface StatCardProps {
  icon: ReactNode;
  value: ReactNode;
  label: string;
  /** Linha extra abaixo do label (ex.: "Plano ilimitado") */
  sublabel?: ReactNode;
  /** Chip de variação (ex.: "↑ 3 posições") */
  delta?: string;
  loading?: boolean;
}

/** Card de métrica do handoff (dashboard e admin) */
export default function StatCard({ icon, value, label, sublabel, delta, loading = false }: StatCardProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "16px",
        p: "22px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 2 }}>
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: "12px",
            backgroundColor: theme.palette.brand.hexTileBg,
            color: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": { fontSize: 22 },
          }}
        >
          {icon}
        </Box>
        {delta && !loading && (
          <Typography
            component="span"
            sx={{
              fontSize: "11px",
              fontWeight: 600,
              color: "success.main",
              backgroundColor: theme.palette.brand.successBg,
              px: "9px",
              py: "3px",
              borderRadius: "100px",
            }}
          >
            {delta}
          </Typography>
        )}
      </Box>

      {loading ? (
        <>
          <Skeleton width={72} height={36} />
          <Skeleton width={120} height={18} />
        </>
      ) : (
        <>
          <Typography sx={{ fontSize: "30px", fontWeight: 700, lineHeight: 1, color: "text.primary" }}>
            {value}
          </Typography>
          <Typography sx={{ mt: "5px", fontSize: "12.5px", color: "text.secondary" }}>{label}</Typography>
          {sublabel && (
            <Typography sx={{ mt: 1, fontSize: "11.5px", fontWeight: 600, color: "success.main" }}>
              {sublabel}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
}
